/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__Answer_5Inputs */

const en_help_center__shipping_n_delivery__answer_5 = /** @type {(inputs: Help_Center__Shipping_N_Delivery__Answer_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For most items, local pickup is not available as products ship directly from suppliers. However, for vehicles, we can arrange pickup at the dealer location if you prefer. Contact support after winning to discuss pickup options.`)
};

/**
* | output |
* | --- |
* | "For most items, local pickup is not available as products ship directly from suppliers. However, for vehicles, we can arrange pickup at the dealer location i..." |
*
* @param {Help_Center__Shipping_N_Delivery__Answer_5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__answer_5 = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__Answer_5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__Answer_5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__shipping_n_delivery__answer_5(inputs)
});